module.exports = __webpack_public_path__ + "img/symbol_13.816f0342.png";